import { Observable, ObservableInput, map, merge } from "rxjs";

/**
 * given a set of labbeled observables, the result observable outputs the values of all.
 * Each value is the second element of a tuple where the first element is the key of the originating observable
 * @param sourcesObject
 * @returns
 * @example taggedMerge({a: of(1), b: of(2)}) => ["a", 1] then ["b", 2]
 */
export function taggedMerge<T extends Record<string, ObservableInput<any>>>(
  sourcesObject: T
): Observable<[string, any]> {
  const sources = Object.keys(sourcesObject).map((key) => {
    return (sourcesObject[key] as Observable<any>).pipe(
      map((internal: any) => [key, internal])
    ) as Observable<[string, any]>;
  });

  return merge(...sources);
}
